<template>
  <control-wrapper
    v-bind="controlWrapper"
    :styles="styles"
    :isFocused="isFocused"
    :appliedOptions="appliedOptions"
  >
    <v-signature-pad
      :id="control.id + '-input'"
      :class="styles.control.input"
      :disabled="!control.enabled"
      :autofocus="appliedOptions.focus"
      :placeholder="appliedOptions.placeholder"
      :label="computedLabel"
      :hint="control.description"
      :persistent-hint="persistentHint()"
      :required="control.required"
      :error-messages="control.errors"
      :value="control.data"
      v-bind="signaturePadProps"
      @input="onChange"
      @focus="isFocused = true"
      @blur="isFocused = false"
    ></v-signature-pad>
  </control-wrapper>
</template>

<script lang="ts">
import {
  and,
  ControlElement,
  isStringControl,
  JsonFormsRendererRegistryEntry,
  optionIs,
  rankWith,
  uiTypeIs,
} from '@jsonforms/core';
import {
  DispatchRenderer,
  rendererProps,
  RendererProps,
  useJsonFormsControl,
} from '@jsonforms/vue2';
import {
  ControlWrapper,
  useTranslator,
  useVuetifyControl,
} from '@jsonforms/vue2-vuetify';
import { defineComponent, computed } from 'vue';
import { VSignaturePad } from '../components/VSignaturePad';

const signatureRenderer = defineComponent({
  name: 'signature-pad-control-renderer',
  components: {
    ControlWrapper,
    DispatchRenderer,
    VSignaturePad,
  },
  props: {
    ...rendererProps<ControlElement>(),
  },
  setup(props: RendererProps<ControlElement>) {
    const t = useTranslator();
    const input = useJsonFormsControl(props);
    const control = useVuetifyControl(input);

    const signaturePadProps = computed(() => {
      const vuetifyProps = control.vuetifyProps('v-signature-pad');
      return {
        ...vuetifyProps,
        activateLabel: t.value(
          vuetifyProps.activateLabel ?? 'Tap To Sign',
          'Tap To Sign'
        ),
      };
    });
    return {
      ...control,
      t,
      signaturePadProps,
    };
  },
});

export default signatureRenderer;

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: signatureRenderer,
  tester: rankWith(
    3,
    and(uiTypeIs('Control'), isStringControl, optionIs('format', 'signature'))
  ),
};
</script>
